import type { ArticlePost, ArticleTeaser } from '@/types';

// Articles complets affiches sur pierresere.com (vitrine d'auteur).
// rel=canonical -> solutions-asterion.com (domicile canonique, pas de duplicate content).
// Genere depuis E:/Travail/asterion-blog via scratchpad/gen-perso.mjs.
import b01 from './articles/rendre-iso-9001-accessible-pme-ia.html?raw';
import b02 from './articles/cout-cache-temps-machiniste-rapports-inspection.html?raw';
import b03 from './articles/revue-direction-iso-9001-sans-consultant.html?raw';
import b04 from './articles/points-critiques-systeme-qualite.html?raw';
import b05 from './articles/ecosysteme-pas-silos-bon-de-travail.html?raw';
import b06 from './articles/metrologie-hors-excel-etalonnage.html?raw';
import b07 from './articles/plans-heberges-quebec-loi-25.html?raw';
import b08 from './articles/ia-qualite-ce-quelle-peut-faire.html?raw';
import b09 from './articles/ocr-plans-cotes-manufacturier.html?raw';
import b10 from './articles/batir-logiciels-metier-ia-encadree.html?raw';
import b11 from './articles/logiciel-qualite-usinage-sorel-tracy.html?raw';
import b12 from './articles/logiciel-qualite-usinage-drummondville.html?raw';
import b13 from './articles/logiciel-qualite-usinage-trois-rivieres-mauricie.html?raw';
import b14 from './articles/logiciel-qualite-usinage-montreal.html?raw';
import b15 from './articles/logiciel-qualite-usinage-saguenay-lac-saint-jean.html?raw';
import b16 from './articles/notre-approche-qualite-pme-manufacturiere.html?raw';
import b17 from './articles/structurer-demarche-qualite-pme-manufacturiere.html?raw';
import b18 from './articles/maturite-systeme-qualite-pme.html?raw';
import b19 from './articles/innovateur-interne-adoption-logiciel-pme.html?raw';
import b20 from './articles/rapport-usinage-inspection-quatre-lectures.html?raw';
import b21 from './articles/jamais-vu-systeme-qualite-pme.html?raw';

export const ARTICLE_POSTS: ArticlePost[] = [
  {
    slug: 'notre-approche-qualite-pme-manufacturiere',
    title: 'Mon approche de la qualité en PME manufacturière : sept principes',
    category: 'MON APPROCHE',
    excerpt: 'Une liste de fonctionnalités ne dit rien : tous les logiciels qualité gèrent les non-conformités et les étalonnages. Ce qui distingue deux outils, c\'est ce que leurs auteurs croient. Voici les sept principes sur lesquels tout ce que nous construisons est bâti…',
    readingMin: 13,
    canonical: 'https://solutions-asterion.com/blog/notre-approche-qualite-pme-manufacturiere',
    body: b16,
  },
  {
    slug: 'structurer-demarche-qualite-pme-manufacturiere',
    title: 'Structurer sa démarche qualité en PME manufacturière : le guide complet',
    category: 'GUIDE',
    excerpt: 'La qualité ne se joue pas le jour de l\'audit, mais dans six gestes du quotidien : voir un problème, savoir d\'où il vient, le traiter à temps, l\'anticiper, décider sur des chiffres, refermer la boucle. Ce guide est la carte — une section par axe, et où lire la suite…',
    readingMin: 14,
    canonical: 'https://solutions-asterion.com/blog/structurer-demarche-qualite-pme-manufacturiere',
    body: b17,
  },
  {
    slug: 'rendre-iso-9001-accessible-pme-ia',
    title: 'Rendre l\'ISO 9001 accessible aux PME : le rôle (réaliste) de l\'IA',
    category: 'Qualité & PME manufacturières',
    excerpt: 'L\'ISO 9001 a la réputation d\'être réservée aux entreprises qui peuvent s\'offrir un ingénieur qualité à temps plein ou un consultant à demeure. Pour beaucoup…',
    readingMin: 14,
    canonical: 'https://solutions-asterion.com/blog/rendre-iso-9001-accessible-pme-ia',
    body: b01,
  },
  {
    slug: 'cout-cache-temps-machiniste-rapports-inspection',
    title: 'Rapports d\'inspection : la vraie facture cachée du temps machiniste',
    category: 'INSPECTION & CONTRÔLE QUALITÉ',
    excerpt: 'Dans un atelier d\'usinage, le rapport d\'inspection n\'est pas de la paperasse : c\'est un livrable obligatoire exigé par le donneur d\'ordre, au même titre que…',
    readingMin: 12,
    canonical: 'https://solutions-asterion.com/blog/cout-cache-temps-machiniste-rapports-inspection',
    body: b02,
  },
  {
    slug: 'revue-direction-iso-9001-sans-consultant',
    title: 'Naviguer sa revue de direction ISO 9001 sans consultant',
    category: 'SYSTÈME QUALITÉ ISO',
    excerpt: 'La revue de direction (§9.3) est l\'exercice ISO 9001 que les PME redoutent le plus : une fois l\'an, la direction doit s\'asseoir, regarder son système qualité…',
    readingMin: 12,
    canonical: 'https://solutions-asterion.com/blog/revue-direction-iso-9001-sans-consultant',
    body: b03,
  },
  {
    slug: 'points-critiques-systeme-qualite',
    title: 'Voir les points critiques de son système qualité d\'un coup d\'œil',
    category: 'AUDIT & CARTOGRAPHIE',
    excerpt: 'Un système qualité ISO 9001, ce n\'est pas une pile de dossiers. C\'est un réseau : une non-conformité pointe vers un processus, une action corrective vers…',
    readingMin: 11,
    canonical: 'https://solutions-asterion.com/blog/points-critiques-systeme-qualite',
    body: b04,
  },
  {
    slug: 'ecosysteme-pas-silos-bon-de-travail',
    title: 'Un écosystème, pas des silos : quand le bon de travail ne se saisit qu\'une fois',
    category: 'NUMÉRISATION DE L\'ATELIER',
    excerpt: 'Dans la plupart des ateliers que je visite, le même bon de travail est ressaisi trois, quatre, cinq fois : une fois pour l\'inspection, une fois dans le…',
    readingMin: 12,
    canonical: 'https://solutions-asterion.com/blog/ecosysteme-pas-silos-bon-de-travail',
    body: b05,
  },
  {
    slug: 'metrologie-hors-excel-etalonnage',
    title: 'La métrologie hors du fichier Excel : ne plus jamais oublier un étalonnage',
    category: 'MÉTROLOGIE',
    excerpt: 'Dans presque tous les ateliers que j\'ai visités, le parc d\'instruments de mesure vit dans un fichier Excel. Une colonne « date du dernier étalonnage », une…',
    readingMin: 11,
    canonical: 'https://solutions-asterion.com/blog/metrologie-hors-excel-etalonnage',
    body: b06,
  },
  {
    slug: 'plans-heberges-quebec-loi-25',
    title: 'Vos plans hébergés au Québec : ce que la Loi 25 change pour votre atelier',
    category: 'SOUVERAINETÉ DES DONNÉES',
    excerpt: 'Les dessins que vos donneurs d\'ordre vous confient et l\'historique qualité que vous accumulez au fil des ans sont des actifs sensibles — au même titre que vos…',
    readingMin: 11,
    canonical: 'https://solutions-asterion.com/blog/plans-heberges-quebec-loi-25',
    body: b07,
  },
  {
    slug: 'ia-qualite-ce-quelle-peut-faire',
    title: 'IA et qualité : ce qu\'elle peut faire, et ce qu\'elle ne doit jamais faire',
    category: 'IA & QUALITÉ',
    excerpt: 'L\'intelligence artificielle est en train d\'entrer dans les ateliers, et deux camps s\'affrontent : ceux qui pensent qu\'elle va tout faire, et ceux qui pensent…',
    readingMin: 11,
    canonical: 'https://solutions-asterion.com/blog/ia-qualite-ce-quelle-peut-faire',
    body: b08,
  },
  {
    slug: 'ocr-plans-cotes-manufacturier',
    title: 'OCR sur plans cotés : pourquoi les outils génériques échouent sur le manufacturier',
    category: 'TECHNOLOGIE & INSPECTION',
    excerpt: 'Un plan coté n\'est pas une lettre ni un contrat. C\'est un objet technique dense : des dimensions, des tolérances, des symboles de tolérancement géométrique,…',
    readingMin: 11,
    canonical: 'https://solutions-asterion.com/blog/ocr-plans-cotes-manufacturier',
    body: b09,
  },
  {
    slug: 'batir-logiciels-metier-ia-encadree',
    title: 'Bâtir des logiciels de métier avec l\'IA encadrée : les coulisses',
    category: 'COULISSES & VISION',
    excerpt: 'J\'ai passé quatorze ans dans la qualité, dont plusieurs à faire du contrôle dimensionnel dans l\'hydroélectrique, avant d\'écrire ma première ligne de code…',
    readingMin: 10,
    canonical: 'https://solutions-asterion.com/blog/batir-logiciels-metier-ia-encadree',
    body: b10,
  },
  {
    slug: 'logiciel-qualite-usinage-sorel-tracy',
    title: 'Sorel-Tracy, de la turbine à la pièce lourde : l\'exigence qualité d\'un pôle métallurgique',
    category: 'SOREL-TRACY & MONTÉRÉGIE',
    excerpt: 'Sorel-Tracy n\'a pas grandi en fabriquant des petites pièces de série. Elle a grandi en coulant de l\'acier, en montant des chaudronneries lourdes et en…',
    readingMin: 7,
    canonical: 'https://solutions-asterion.com/blog/logiciel-qualite-usinage-sorel-tracy',
    body: b11,
  },
  {
    slug: 'logiciel-qualite-usinage-drummondville',
    title: 'Drummondville : la force — et le casse-tête qualité — d\'un manufacturier qui touche à tout',
    category: 'DRUMMONDVILLE & CENTRE-DU-QUÉBEC',
    excerpt: 'Drummondville n\'a pas une industrie, elle en a dix. Métal, machinerie, plasturgie, meuble, agroalimentaire, transport, sous-traitance pour le pôle industriel…',
    readingMin: 7,
    canonical: 'https://solutions-asterion.com/blog/logiciel-qualite-usinage-drummondville',
    body: b12,
  },
  {
    slug: 'logiciel-qualite-usinage-trois-rivieres-mauricie',
    title: 'De l\'hydroélectricité à l\'aluminium : un siècle d\'industrie en Mauricie, et la qualité qui va avec',
    category: 'TROIS-RIVIÈRES & MAURICIE',
    excerpt: 'La Mauricie est le berceau de l\'hydroélectricité au Québec. C\'est à Shawinigan, tout au début du XXᵉ siècle, qu\'on a harnaché la rivière Saint-Maurice pour…',
    readingMin: 7,
    canonical: 'https://solutions-asterion.com/blog/logiciel-qualite-usinage-trois-rivieres-mauricie',
    body: b13,
  },
  {
    slug: 'logiciel-qualite-usinage-montreal',
    title: 'Usinage aéronautique du Grand Montréal : quand la preuve pèse autant que la pièce',
    category: 'MONTRÉAL & GRAND MONTRÉAL',
    excerpt: 'Le Grand Montréal est l\'un des rares endroits au monde où l\'on peut assembler un avion complet sans quitter la région. Cette grappe aéronautique tire vers le…',
    readingMin: 7,
    canonical: 'https://solutions-asterion.com/blog/logiciel-qualite-usinage-montreal',
    body: b14,
  },
  {
    slug: 'logiciel-qualite-usinage-saguenay-lac-saint-jean',
    title: 'Saguenay–Lac-Saint-Jean : usiner pour la grande industrie, loin des grands centres',
    category: 'SAGUENAY–LAC-SAINT-JEAN',
    excerpt: 'Il n\'existe pas au Québec de région où l\'industrie lourde soit aussi présente, aussi ancienne et aussi structurante qu\'au Saguenay–Lac-Saint-Jean. L\'aluminium…',
    readingMin: 8,
    canonical: 'https://solutions-asterion.com/blog/logiciel-qualite-usinage-saguenay-lac-saint-jean',
    body: b15,
  },
  {
    slug: 'maturite-systeme-qualite-pme',
    title: 'Votre système qualité est-il réactif, ou sous contrôle ?',
    category: 'Système qualité & pilotage',
    excerpt: 'Tout le monde vous demande où vous en êtes, et vous répondez ce que tout le monde répond : « on est certifié ISO 9001 ». C\'est vrai, et ça ne dit à peu près rien. Voici une échelle de maturité en cinq niveaux qui tient dans un atelier de trente…',
    readingMin: 15,
    canonical: 'https://solutions-asterion.com/blog/maturite-systeme-qualite-pme',
    body: b18,
  },
  {
    slug: 'innovateur-interne-adoption-logiciel-pme',
    title: 'L\'innovateur que vous cherchez travaille déjà chez vous',
    category: 'ÉQUIPE & CHANGEMENT',
    excerpt: 'Quand un logiciel ne prend pas dans un atelier, on accuse le logiciel. Presque toujours à tort. Ce qui bloque, ce sont des gens : ceux du plancher qui ont peur de ce que l\'outil va révéler d\'eux, et la direction qui ne comprend pas ce que fait la personne qui pousse. Or cette personne existe déjà…',
    readingMin: 17,
    canonical: 'https://solutions-asterion.com/blog/innovateur-interne-adoption-logiciel-pme',
    body: b19,
  },
  {
    slug: 'rapport-usinage-inspection-quatre-lectures',
    title: 'Rapport d\'usinage, rapport d\'inspection : quatre personnes lisent le même document',
    category: 'RAPPORT D\'INSPECTION',
    excerpt: 'Le machiniste y voit une corvée qui met sa pièce en doute. L\'inspecteur, une signature qui l\'engage sur des mesures qu\'il n\'a pas toutes refaites. Le patron, un coût qui n\'apparaît sur aucune soumission. Et chez le client, le vérificateur tranche Go/No-Go sans jamais voir la pièce. Les quatre ont raison en même temps…',
    readingMin: 15,
    canonical: 'https://solutions-asterion.com/blog/rapport-usinage-inspection-quatre-lectures',
    body: b20,
  },
  {
    slug: 'jamais-vu-systeme-qualite-pme',
    title: 'En quatorze ans, je n\'ai jamais vu de système qualité dans une PME',
    category: 'OPINION',
    excerpt: 'Pendant quatorze ans, je n\'ai jamais vu de vrai système de gestion de la qualité dans une PME. Partout, le même montage maison — Excel, dossiers réseau, le module oublié de l\'ERP — que personne n\'a conçu et que tout le monde a hérité. Et si la personne qui le comprend partait demain ?…',
    readingMin: 10,
    canonical: 'https://solutions-asterion.com/blog/jamais-vu-systeme-qualite-pme',
    body: b21,
  },
];

export function getArticle(slug: string): ArticlePost | undefined {
  return ARTICLE_POSTS.find((p) => p.slug === slug);
}

/**
 * Cartes de l index francais : les articles sont heberges ici, donc les liens
 * restent internes. La version anglaise (`data/en`) pointe, elle, vers le blog
 * Asterion ou vivent les traductions.
 */
export const ARTICLE_TEASERS: ArticleTeaser[] = ARTICLE_POSTS.map((post) => ({
  slug:       post.slug,
  title:      post.title,
  category:   post.category,
  excerpt:    post.excerpt,
  readingMin: post.readingMin,
  href:       `/articles/${post.slug}`,
  isExternal: false,
}));
